import { api, ApiError, unwrap } from '../../../api/client';
import type { VariantSummary } from './api';
import { dec, isDecimal } from './decimal';

/**
 * Scanner / search entry parsing and exact code lookup — shared by the fast-sale counter, the
 * document editors and the POS module.
 */

/** "3*8961000000011" or "3x LED" — a quantity in front of a code or search. */
export function parseEntry(raw: string): { qty: string; text: string } {
  const m = /^\s*(\d+(?:\.\d+)?)\s*[*x×]\s*(.+)$/i.exec(raw);
  if (m?.[1] && m[2] && isDecimal(m[1]) && dec(m[1]) > 0n) return { qty: m[1], text: m[2].trim() };
  return { qty: '1', text: raw.trim() };
}

/** Exact barcode or SKU lookup; null when nothing has that code (other errors are thrown). */
export async function lookupVariant(code: string): Promise<VariantSummary | null> {
  try {
    return await unwrap(api.GET('/variants/lookup', { params: { query: { code } } }));
  } catch (e) {
    if (e instanceof ApiError && e.status === 404) return null;
    throw e;
  }
}
